/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// import './ContentEditable.css';

import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import type { JSX } from 'react';
import * as React from 'react';

type ContentEditableProps = Omit<
  React.ComponentProps<typeof ContentEditable>,
  'className' | 'placeholder' | 'aria-placeholder'
>;

type Props = ContentEditableProps & {
  className?: string;
  placeholder?: string;
};

export default function LexicalContentEditable({
  className,
  placeholder,
  ...others
}: Props): JSX.Element {
  return (
    <ContentEditable
      className={className || 'ContentEditable__root'}
      placeholder={() => <span>{placeholder || ''}</span>} // 항상 Element 또는 함수
      aria-placeholder={placeholder || ''} // string
      {...others}
    />
  );
}
